<template>
  <div class="pa-tutorial-wrapper">
    <PATutorialEntrance
     :isOpen="isOpenEntrance"
     @loadedModal="handleLoadedModal"
     @onSubmit="handleOnSubmit"
     @onCancel="handleOnCancel"
    />

    <PACustomTour
     name="paTutorialHome"
     :steps="homeTutorial.steps"
     :options="homeTutorial.options"
     :callbacks="homeTutorial.callbacks"
    />

    <PACustomTour
     name="paTutorialOffice"
     :steps="officeTutorial.steps"
     :options="officeTutorial.options"
     :callbacks="officeTutorial.callbacks"
    />

    <PACustomTour
     name="paTutorialPark"
     :steps="parkTutorial.steps"
     :options="parkTutorial.options"
     :callbacks="parkTutorial.callbacks"
    />

    <PACustomTour
     name="paTutorialConnection"
     :steps="connectionTutorial.steps"
     :options="connectionTutorial.options"
     :callbacks="connectionTutorial.callbacks"
    />

    <PATutorialFinal
     :isOpen="isOpenFinal"
     @loadedModal="handleLoadedFinalModal"
     @onSubmit="handleOnFinalSubmit"
    />
  </div>
</template>

<script>
import PATutorialEntrance     from '@/components/Parts/PATutorial/PATutorialEntrance.vue'
import PACustomTour           from '@/components/Parts/PATutorial/PACustomTour/PACustomTour.vue'
import PATutorialFinal        from '@/components/Parts/PATutorial/PATutorialFinal.vue'

import CharacterMetaMixins    from '@/mixins/CharacterMetaMixins.js'

import PATutorialHomeMixin       from '@/components/Parts/PATutorial/mixins/PATutorialHomeMixin.js'
import PATutorialOfficeMixin     from '@/components/Parts/PATutorial/mixins/PATutorialOfficeMixin.js'
import PATutorialParkMixin       from '@/components/Parts/PATutorial/mixins/PATutorialParkMixin.js'
import PATutorialConnectionMixin from '@/components/Parts/PATutorial/mixins/PATutorialConnectionMixin.js'

export default {
  components : {
    PATutorialEntrance,
    PACustomTour,
    PATutorialFinal
  },

  mixins : [
    CharacterMetaMixins,
    PATutorialHomeMixin,
    PATutorialOfficeMixin,
    PATutorialParkMixin,
    PATutorialConnectionMixin
  ],

  data(){
    return {
      couldShowTutorial : false,
      isOpenEntrance    : false,

      isOpenFinal       : false
    };
  },

  computed : {
    isMountedLoginedViewPage(){
      return this.$store.state.layouts.isMountedLoginedViewPage;
    },

    shouldOpenEntrance(){
      return this.$store.state.tutorial.shouldOpenEntrance;
    },

    shouldOpenFinal(){
      return this.$store.state.tutorial.shouldOpenFinal;
    },

    shouldOpenTour(){
      return this.$store.state.tutorial.shouldOpenTour;
    },

    tourType(){
      return this.$store.state.tutorial.tourType;
    },

    routingPosition(){
      return this.$store.state.routingPosition;
    },

    isEnterdMessageRoom(){
      return this.$store.state.message.isEnterdMessageRoom;
    }
  },

  watch : {
    characterMetaData : {
      handler(data){
        if(data === {}) return;

        if(typeof data['tutorial.couldShowTutorial'] !== 'undefined'){
          this.couldShowTutorial = data['tutorial.couldShowTutorial'];
        }
      },
      immediate: true,
      deep: true
    },

    couldShowTutorial : {
      handler(){
        this.checkShowTutorial();
      }
    },

    isMountedLoginedViewPage : {
      handler(){
        this.checkShowTutorial();
      }
    },

    shouldOpenFinal : {
      handler(value){
        if(typeof value === 'undefined') return;

        this.isOpenFinal = value;
      },
      immediate: true
    },

    shouldOpenEntrance : {
      handler(value){
        if(typeof value === 'undefined') return;

        if(value === true){
          // If application path wasnt home, redirect it.
          if(this.routingPosition !== 'home'){
            this.$router.push({ name: 'home' });
          }

          this.$store.dispatch({
            type  : 'tutorial/updateTourType',
            value : 'through',
          });
        }

        this.isOpenEntrance = value;
      },
      immediate: true
    },

    shouldOpenTour : {
      handler(data){
        if(data.home === true){
          this.startHomeTour();
        }

        if(data.office === true){
          this.startOfficeTour();
        }

        if(data.park === true){
          this.startParkTour();
        }

        if(data.connection === true){
          this.startConnectionTour();
        }
      },
      deep: true
    },

    isOpenFinal : {
      handler(value){
        if(value === true){
          // If application path wasnt home, redirect it.
          if(this.routingPosition !== 'home'){
            this.$router.push({ name: 'home' });
          }
        }
      }
    }
  },

  methods : {
    startConnectionTour(){
      if(this.isConnectionEntrance === true){
        if(this.routingPosition !== 'home'){
          this.$router.push({ name: 'home' });
        }

        this.connectionTourTemplateType = 'entrance';
      }else{
        if(this.routingPosition !== 'park'){
          this.$router.push({ name: 'connections.room' });
        }

        this.connectionTourTemplateType = 'enterd';
      }

      this.$nextTick(() => {
        this.$tours['paTutorialConnection'].start();
      });
    },

    startParkTour(){
      if(this.isParkEntrance === true){
        if(this.routingPosition !== 'home'){
          this.$router.push({ name: 'home' });
        }

        this.parkTourTemplateType = 'entrance';
      }else{
        if(this.routingPosition !== 'park'){
          this.$router.push({ name: 'parks.view' });
        }

        this.parkTourTemplateType = 'enterd';
      }

      this.$nextTick(() => {
        this.$tours['paTutorialPark'].start();
      });
    },

    startHomeTour(){
      if(this.routingPosition !== 'home'){
        this.$router.push({ name: 'home' });
      }

      this.$nextTick(() => {
        this.$tours['paTutorialHome'].start();
      });
    },

    startOfficeTour(){
      if(this.routingPosition !== 'office'){
        this.$router.push({ name: 'office' });

        const intervalId = setInterval(async () => {
          if(this.isEnterdMessageRoom === true){
            clearInterval(intervalId);

            this.$nextTick( async () => {
              await this.UXWaiting(1000);

              console.log('started office tour');
              this.$tours['paTutorialOffice'].start();
            });
          }
        }, 100);

        setTimeout(() => {
          clearInterval(intervalId);
        }, 10000);
      }else{
        this.$nextTick( async () => {
          this.$tours['paTutorialOffice'].start();
        });
      }
    },

    handleLoadedModal(){
      // デバック中はオフ
      this.updateCharacterMeta({
        'tutorial.couldShowTutorial'  : false
      });
    },

    handleOnSubmit(){
      this.$store.dispatch({
        type  : 'tutorial/updateShouldOpenEntrance',
        value : false
      });

      this.$store.dispatch({
        type  : 'tutorial/updateShouldOpenTour',
        name  : 'home'
      });
    },

    handleOnCancel(){
      this.$store.dispatch({
        type  : 'tutorial/updateShouldOpenEntrance',
        value : false
      });
    },

    checkShowTutorial(){
      if(this.isMountedLoginedViewPage === true && this.couldShowTutorial === true){
        this.$nextTick( async () => {
          await this.UXWaiting(350);

          this.$store.dispatch({
            type  : 'tutorial/updateShouldOpenEntrance',
            value : true
          });
        });
      }
    },

    handleLoadedFinalModal(){
      
    },

    handleOnFinalSubmit(){
      this.$store.dispatch({
        type   : 'tutorial/updateShouldOpenFinal',
        value  : false
      });
    }
  }
}
</script>